var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81937 0.651607C8.04571 -0.0449915 9.03121 -0.0449934 9.25755 0.651605L10.7453 5.23031C10.8465 5.54184 11.1368 5.75276 11.4644 5.75276H16.2787C17.0111 5.75276 17.3157 6.69003 16.7231 7.12055L12.8282 9.95035C12.5632 10.1429 12.4523 10.4842 12.5536 10.7957L14.0413 15.3744C14.2676 16.071 13.4703 16.6503 12.8778 16.2197L8.98288 13.3899C8.71788 13.1974 8.35904 13.1974 8.09404 13.3899L4.19915 16.2197C3.60659 16.6503 2.80931 16.071 3.03565 15.3744L4.52336 10.7957C4.62458 10.4842 4.51369 10.1429 4.24869 9.95035L0.35381 7.12055C-0.238752 6.69003 0.0657828 5.75276 0.79823 5.75276H5.61257C5.94013 5.75276 6.23044 5.54184 6.33166 5.23031L7.81937 0.651607Z",
    fill: "#E9980E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star_fill.b4b6563f6bb015d9dbc76f042265c85f.svg";
export { ForwardRef as ReactComponent };